import { createSlice, current } from '@reduxjs/toolkit'


const initialState = {
    responses: [],
    showResults: false,
    searching: false,
    tripDest: null,
    sessionId: ""
}

export const AiChatBoxSlice = createSlice({
    name: 'AiChatBox',
    initialState: initialState,
    reducers: {
        toggleAiResults: (state, action) => {
            state.showResults = action.payload
        },
        updateAiResponses: (state, action) => {
            state.responses = action.payload;
        },
        updateAiSearching: (state, action) => {
            state.searching = action.payload;
        },
        updateTripDest: (state, action) => {
            state.tripDest = action.payload;
        },
        updateSessionId: (state, action) => {
            state.sessionId = action.payload;
        },

    },
    extraReducers: {


    },

})

export const { updateTripDest, toggleAiResults, updateAiSearching, updateAiResponses, updateSessionId } = AiChatBoxSlice.actions;
export const AiChatBoxReducer = AiChatBoxSlice.reducer;